var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, CircularProgress, Typography } from '@mui/material';
import { usePreviewLoop } from 'hx-din-test-2';
import { StepLayout } from '../step-layout.component';
import { pageImages } from '@/pages/images';
import { VolumeSelectContent } from './volume-select-content.component';
import { InformationToggle } from '../information-toggle.component';
import { palette } from '@/theme/palette';
import { NavigationButton, NavigationButtonsContainer } from '../navigation-button.component';
import { useStyledModal } from '../modals/styled-modal.hook';
import { HeadphoneCheckModalContent } from '../headphone-check/components/headphone-check-modal-content.component';
export function VolumeSelect() {
    var state = usePreviewLoop().dinPlayer.state;
    var _a = useStyledModal({
        header: 'Troubleshooting',
        content: _jsx(HeadphoneCheckModalContent, {}),
        buttonProps: {
            text: 'Dismiss'
        }
    }), toggleStyledModal = _a.toggleStyledModal, styledModal = _a.styledModal;
    if (state.status === 'initializing')
        return (_jsx("div", __assign({ className: "grid w-full h-full place-items-center" }, { children: _jsx(CircularProgress, {}) })));
    return (_jsx(StepLayout, { image: pageImages.womanScrolling, heading: _jsx(Typography, __assign({ variant: "h3", className: "md:pt-6 lg:pt-12 xl:pt-[72px] font-extrabold text-charcoal text-2xl lg:text-4xl" }, { children: "Set your volume" })), progress: {
            phase: 0,
            step: 6,
        }, content: _jsx(VolumeSelectContent, {}), info: _jsxs("div", __assign({ className: 'flex flex-col gap-3' }, { children: [_jsx(Button, __assign({ variant: 'text', onClick: function () { return toggleStyledModal(); }, className: 'underline font-medium text-charcoal hover:bg-transparent hover:font-bold' }, { children: "Sound not playing?" })), _jsx(InformationToggle, __assign({ title: 'What is a "comfortable" setting?', chevronColor: palette.primary.main }, { children: _jsx(Typography, { children: "Set the volume so speech sounds clear and natural\u2014not too soft or too loud." }) })), styledModal] })), nav: _jsxs(NavigationButtonsContainer, __assign({ className: 'mb-6' }, { children: [_jsx(NavigationButton, { type: "back", variant: "outlined", label: "Previous" }), _jsx(NavigationButton, { type: "submit", variant: "contained", label: "Next" })] })) }));
}
